export interface IFailureModeOption {
  id: string;
  label: string;
}

export const FAILURE_MODES_LIST: IFailureModeOption[] = [
  { id: '0.0', label: '0.0 Acessórios e outros' },
  { id: '1.0', label: '1.0 Motor' },
  { id: '1.1', label: '1.1 Embreagem (embreagem, incluindo sistema de acionamento)' },
  { id: '10.0', label: '10.0 Revisão' },
  { id: '11.0', label: '11.0 Software' },
  { id: '12.0', label: '12.0 Sinistro' },
  { id: '13.0', label: '13.0 Ação de campo' },
  { id: '2.0', label: '2.0 Combustível, gás de escape e arrefecimento (pós tratamento)' },
  { id: '2.1', label: '2.1 Pós-tratamento' },
  { id: '3.0', label: '3.0 Caixa de mudança' },
  { id: '4.0', label: '4.0 Eixo e caixa de direção' },
  { id: '4.1', label: '4.1 Sistema de suspensão dianteira' },
  { id: '4.2', label: '4.2 Sistema de direção' },
  { id: '5.0', label: '5.0 Eixo traseiro' },
  { id: '5.1', label: '5.1 Rolamento de roda' },
  { id: '5.2', label: '5.2 Sistema de suspensão traseira' },
  { id: '6.0', label: '6.0 Sistema de freio e circuito pneumático' },
  { id: '7.0', label: '7.0 Sistema de alavanca (pedaleira e cabos de marcha)' },
  { id: '8.0', label: '8.0 Carroceria' },
  { id: '8.1', label: '8.1 Chassi' },
  { id: '9.0', label: '9.0 Sistema elétrico' },
];

export const FAILURE_MODE_LABEL_ID_MAP: Record<string, string> = {
  '0.0': 'intl-msg:budgets.shared.failureMode.mode0_0',
  '1.0': 'intl-msg:budgets.shared.failureMode.mode1_0',
  '1.1': 'intl-msg:budgets.shared.failureMode.mode1_1',
  '10.0': 'intl-msg:budgets.shared.failureMode.mode10_0',
  '11.0': 'intl-msg:budgets.shared.failureMode.mode11_0',
  '12.0': 'intl-msg:budgets.shared.failureMode.mode12_0',
  '13.0': 'intl-msg:budgets.shared.failureMode.mode13_0',
  '2.0': 'intl-msg:budgets.shared.failureMode.mode2_0',
  '2.1': 'intl-msg:budgets.shared.failureMode.mode2_1',
  '3.0': 'intl-msg:budgets.shared.failureMode.mode3_0',
  '4.0': 'intl-msg:budgets.shared.failureMode.mode4_0',
  '4.1': 'intl-msg:budgets.shared.failureMode.mode4_1',
  '4.2': 'intl-msg:budgets.shared.failureMode.mode4_2',
  '5.0': 'intl-msg:budgets.shared.failureMode.mode5_0',
  '5.1': 'intl-msg:budgets.shared.failureMode.mode5_1',
  '5.2': 'intl-msg:budgets.shared.failureMode.mode5_2',
  '6.0': 'intl-msg:budgets.shared.failureMode.mode6_0',
  '7.0': 'intl-msg:budgets.shared.failureMode.mode7_0',
  '8.0': 'intl-msg:budgets.shared.failureMode.mode8_0',
  '8.1': 'intl-msg:budgets.shared.failureMode.mode8_1',
  '9.0': 'intl-msg:budgets.shared.failureMode.mode9_0',
};

export const getFailureModeLabelId = (failureModeId: string): string | undefined => {
  return Object.prototype.hasOwnProperty.call(FAILURE_MODE_LABEL_ID_MAP, failureModeId)
    ? FAILURE_MODE_LABEL_ID_MAP[failureModeId]
    : undefined;
};
